import React, { useEffect, useState } from 'react'
import AdminHeader from './AdminHeader'
import { Tabs, message } from 'antd';
import { PhoneOutlined, HomeOutlined, ShareAltOutlined, UserOutlined, CodeOutlined, UserSwitchOutlined, LaptopOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import AdminHeroSection from './AdminHeroSection';
import AdminIntro from './AdminIntro';
import AdminExperience from './AdminExperience';
import AdminProject from './AdminProject';
import AdminContact from './AdminContact';
import AdminSocial from './AdminSocial';
import AdminHome from './AdminHome';
import Footer from "../components/Footer"
import { useNavigate } from "react-router-dom"; // Import useHistory from react-router-dom





const AdminIndex = () => {

  const { portfolioData } = useSelector((state) => state.root);
  let navigate = useNavigate();
  const items = [
    {
      key: '1',
      label: 'Home',
      children: <AdminHome />,
      icon: <HomeOutlined />
    },
    {
      key: '2',
      label: 'HeroSection',
      children: <AdminHeroSection />,
      icon: <UserSwitchOutlined />
    },
    {
      key: '3',
      label: 'About',
      children: <AdminIntro />,
      icon: <UserOutlined />
    },
    {
      key: '4',
      label: 'Experiences',
      children: <AdminExperience />,
      icon: <LaptopOutlined />
    },
    {
      key: '5',
      label: 'Projects',
      children: <AdminProject />,
      icon: <CodeOutlined />
    },
    {
      key: '6',
      label: 'Contact',
      children: <AdminContact />,
      icon: <PhoneOutlined />
    },
    {
      key: '7',
      label: 'Social',
      children: <AdminSocial />,
      icon: <ShareAltOutlined />
    },
  ];
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const tabPosition = windowWidth <= 768 ? 'top' : 'left'; // Adjust the breakpoint as needed
  useEffect(() => {
    if (localStorage.getItem("token") === null) {
      message.error("Please Login.");
      navigate("/login");
    }

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div>
      {portfolioData && (
        <div>
          <AdminHeader />

          <div className=' pe-6 py-4 sm:p-2 bg-zinc-50'>
            <Tabs defaultActiveKey="1" size="large" itemColor="#4096ff" tabPosition={tabPosition} itemActiveColor="#2b1b40ff" items={items} />
          </div>

          <Footer />
        </div>

      )
      }
    </div >
  )
}

export default AdminIndex
